import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/modules/current-user/permissions/permissions';
import { encodeSearchQueryParams } from '@@/packages/shared/libs/search/useQueryParams';
import { searchQueryParamsLatestScanResultFindingsForAsset } from './composables';

export const supplierMonitoringRoutes = [
  {
    path: 'monitoring',
    component: () => import('./SupplierMonitoring.vue'),
    children: [
      {
        path: 'scans',
        name: 'supplier-monitoring-scans',
        components: {
          default: () => import('./SupplierMonitoringScans.vue'),
          hero: () => import('./SupplierMonitoringScansHero.vue'),
        },
      },
      {
        path: 'domains',
        name: 'supplier-monitoring-domains',
        components: {
          default: () => import('@/modules/external-monitoring/AssetsPage.vue'),
          hero: () => import('@/modules/external-monitoring/AssetsHero.vue'),
        },
      },
      {
        path: 'findings',
        name: 'supplier-monitoring-findings',
        components: {
          default: () => import('./SupplierFindings.vue'),
          hero: () => import('./FindingsHero.vue'),
        },
      },
      {
        path: 'findings/asset/:assetName?',
        name: 'supplier-monitoring-findings-of-asset',
        redirect: (route) => ({
          name: 'supplier-monitoring-findings',
          query: encodeSearchQueryParams(
            searchQueryParamsLatestScanResultFindingsForAsset(
              Array.isArray(route.params.assetName)
                ? route.params.assetName[0]
                : route.params.assetName,
            ),
          ),
          params: { ...route.params, assetName: undefined },
          replace: true,
        }),
      },
      {
        path: '',
        redirect: { name: 'supplier-monitoring-scans' },
      },
    ],
    meta: {
      permissions: [Permission.SuppliersExternalMonitoringView],
    },
  },
] satisfies RouteRecordRaw[];
